import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=f687fb8a&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=f687fb8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f687fb8a",
  null
  
)

/* custom blocks */
import block0 from "./i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Ffrechdax-abdl%2Ffrechdax-abdl-italy%2Fweb%2Fwebapp%2Fsrc%2Fcomponents%2Fnewsletter%2FNewsletter.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/global.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Ffrechdax-abdl%2Ffrechdax-abdl-italy%2Fweb%2Fwebapp%2Fsrc%2Fcomponents%2Fnewsletter%2FNewsletter.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports